import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core';

@Directive({
  selector: '[appFormatCurrency]',
})
export class CurrencyDirective {
  @Output()
  public updateFormatCurrency: EventEmitter<string> =
    new EventEmitter<string>();
  constructor(private el: ElementRef) {}

  @HostListener('keyup', ['$event'])
  onKeyup($event: any) {
    const initalValue = this.el.nativeElement.value.replace(/[^0-9]*/g, '');
    const numberValue: number = parseInt(initalValue, 10);
    const valueFormatted = (parseFloat(numberValue / 100 + '') || 0.0)
      .toFixed(2)
      .split('.')
      .join(',');
    this.el.nativeElement.value = valueFormatted;
    this.updateFormatCurrency.emit(valueFormatted);
    if (initalValue !== this.el.nativeElement.value) {
      $event.stopPropagation();
    }
  }
}
